import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useFetchAppointmentPdf } from 'Features/ContractRelease/Services/release.service';
import View from './CheckPDF.view';

const CheckPDF = ({
    currentContract,
    viewCheckPDF,
    handlePDFChecked,
    handleClosedPDF,
    grouping
}) => {
    const {description, type, template, year, appointee : { appointmentId } } = currentContract;
    const [pdf, setPdf] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [checkedCount, setCheckedCount] = useState(0);

    const { isLoading, isSuccess } = useFetchAppointmentPdf(year, type, appointmentId, setPdf);
    const isFail = !isLoading && !isSuccess;
    const title = `${description} (${type}), ${template} (${year})`;

    const handleCloseRequested = () => {
        if (viewCheckPDF && checkedCount > 0) {
            setShowModal(true);
        } else {
            handleClosedPDF();
        }
    };

    const handleCancelConfirmed = () => {
        handleClosedPDF();
    };

    const handleCancelWithdrawn = () => {
        setShowModal(false);
    };

    const updateCheckedCount = count => setCheckedCount(count);

    return (
        <View
            title={title}
            pdf={pdf}
            isLoading={isLoading}
            isSuccess={isSuccess}
            isFail={isFail}
            isChecking={viewCheckPDF}
            handlePDFChecked={handlePDFChecked}
            handleClosedPDF={handleCloseRequested}
            grouping={grouping}
            showModal={showModal}
            handleCancelConfirmed={handleCancelConfirmed}
            handleCancelWithdrawn={handleCancelWithdrawn}
            updateCheckedCount={updateCheckedCount}
        />
    );
};

CheckPDF.propTypes = {
    currentContract: PropTypes.any,
    viewCheckPDF: PropTypes.bool.isRequired,
    handlePDFChecked: PropTypes.func.isRequired,
    handleClosedPDF: PropTypes.func.isRequired,
    grouping: PropTypes.string.isRequired
};

export default CheckPDF;

